import * as Yup from 'yup';

const MAX_FREIGHT_VALUE = 999999999999.99;

export const schema = Yup.object().shape({
  takerValue: Yup.number()
    .moreThan(0, 'O valor deve ser maior que zero')
    .max(MAX_FREIGHT_VALUE, 'Valor frete base excede o limite permitido')
    .required('Campo obrigatório'),
  loadValueType: Yup.object()
    .required('Campo obrigatório')
    .shape({
      value: Yup.string().required('Campo obrigatório'),
    })
    .typeError('Campo obrigatório'),
  negotiationType: Yup.object()
    .required('Campo obrigatório')
    .shape({
      value: Yup.string().required('Campo obrigatório'),
    })
    .typeError('Campo obrigatório'),
  balance: Yup.number().when('$isAttended', {
    is: true,
    then: (schema) =>
      schema.moreThan(0, 'O valor deve ser maior que zero').required('Campo obrigatório'),
    otherwise: (schema) => schema,
  }),
});
